// 🔧 fixed/updated by ChatGPT on 2025-10-19 10:15:08 – reason: keep existing store intact; add helpers to reliably access uid and initialize from localStorage (START)
import { create } from "zustand";

const LS_KEY = "klmn_auth_user_v1";

export const useAuthStore = create((set, get) => ({
  user: null,
  isLoading: false,
  error: null,

  init() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (raw) set({ user: JSON.parse(raw) });
    } catch {}
  },

  setUser(user) {
    set({ user, error: null });
    try {
      if (user) localStorage.setItem(LS_KEY, JSON.stringify(user));
      else localStorage.removeItem(LS_KEY);
    } catch {}
  },

  setLoading(isLoading) {
    set({ isLoading });
  },

  setError(error) {
    set({ error });
  },

  logout() {
    set({ user: null });
    try { localStorage.removeItem(LS_KEY); } catch {}
  },

  isAuthenticated() {
    return !!get().user;
  },
  hasRole(role) {
    const u = get().user;
    return !!u && (u.role === role || u.roles?.includes?.(role));
  },

  // added helper to always read uid consistently across app
  getUid() {
    const u = get().user;
    return u?.uid || u?.id || u?.userId || null;
  }
}));
// 🔧 fixed/updated by ChatGPT on 2025-10-19 10:15:08 (END)
